import {paragraphCarrousel} from "./src/ParagraphCarrousel";
import {paragraphCocktail} from "./src/ParagraphCocktail";
import {paragraphProducts} from "./src/ParagraphProducts";
import {paragraphMoreInfos} from "./src/ParagraphMoreInfos";
import {instagramSocialWall} from "./src/InstagramSocialWall";

(function (Drupal) { // closure
    'use strict';
    Drupal.behaviors.paragraphCarrousel = paragraphCarrousel;
    Drupal.behaviors.paragraphCocktail = paragraphCocktail;
    Drupal.behaviors.paragraphProducts = paragraphProducts;
    Drupal.behaviors.paragraphMoreInfos = paragraphMoreInfos;
    Drupal.behaviors.instagramSocialWall = instagramSocialWall;
}(Drupal));

